/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import SuccessLottie from '../../config/1127-success.json';
import { Button } from 'react-bootstrap';
import { ConfirmModal } from '../ConfirmModal';
import { PaymentSummary } from '../PaymentSummary';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

interface IAcknowledgementProps {
  title: string;
  subTitle: string;
  paraTitle: string;
  para1?: string;
  submitBtnText?: string;
  link: string;
  onSubmit?(): void;
  onPayClick?(): void;
  linkText: string;
  confirmModalContent?: any;
  paymentLink?: string;
  paymentSummary?: any;
  para2?: string;
  appNoTitle: string;
  applicationNo?: string;
}

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export const Acknowledgement = ({
  linkText,
  link,
  para1,
  para2,
  paraTitle,
  submitBtnText,
  onSubmit,
  subTitle,
  paymentLink,
  onPayClick,
  title,
  paymentSummary,
  confirmModalContent,
  appNoTitle,
  applicationNo,
}: IAcknowledgementProps) => {
  const _onPayClick = async () => {
    //@ts-ignore
    const result = await SwalWithBootstrapButtons.fire({
      icon: 'warning',
      title: 'Confirm Payment',
      text: 'Are you sure do you want to Pay?',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      onPayClick && onPayClick();
    }
  };
  const history = useNavigate();
  return (
    <>
      <div className="mt-5">
        <h4 className="text-center fw-bold">{title}</h4>
        <h5 className="text-center">{subTitle}</h5>
        <h6 className="text-center mt-1 text-secondary">
          {`${appNoTitle}`}
          <span style={{ fontWeight: 700 }}>{applicationNo}</span>
        </h6>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Lottie
            animationData={SuccessLottie}
            loop={true}
            style={{ width: '20%' }}
          />
        </div>
        <div>
          {submitBtnText && (
            <div className={`d-flex justify-content-center w-100`}>
              <Button onClick={_onPayClick}>{submitBtnText}</Button>
            </div>
          )}
        </div>

        {/* <h5 className="text-center mt-5 text-secondary">{paraTitle}</h5> */}

        <p className="text-center mt-4">
          {para1 && para1}
          <span
            className="link-info text-decoration-underline"
            style={{ cursor: 'pointer' }}
            onClick={() => history(link)}
          >
            {' '}
            {linkText}
          </span>
          {para2 && para2}
        </p>
      </div>
    </>
  );
};
